import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: Array<ITableColumnMetadata> = [
  {
    key: 'name',
    displayName: 'Usuario'
  },
  {
    key: 'email',
    displayName: 'Correo electrónico'
  },
  {
    key: 'displayedRole',
    displayName: 'Permiso'
  },

  {
    key: 'status',
    displayName: 'Estado',
    type: 'status',
    statusMap: {
      Activo: {
        text: 'Activo',
        background: 'success'
      },
      Bloqueado: {
        text: 'Bloqueado',
        background: 'danger'
      }
    }
  },
  {
    key: 'creationDate',
    displayName: 'Fecha',
    type: 'date'
  },
  {
    key: 'id',
    displayName: 'Acción',
    type: 'action',
    actions: ['EDIT', 'DELETE']
  }
];

export default tableColumnMetadata;
